/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { Box, Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Kpi from "../../components/KPI/Kpi";
import { ReactComponent as StoreCircleIcon } from "../../assets/icons/store-circle.svg";
import { ReactComponent as TrophyCircleIcon } from "../../assets/icons/trophy-circle.svg";
import NorthRoundedIcon from "@mui/icons-material/NorthRounded";
import ProgressBar from "../../components/ProgressBar/ProgressBar";

function DetailsDesktop({ app, config }) {
	const notFullHd = useMediaQuery({ query: "(max-width: 1536px)" });

	const { selections } = useSelections();
	const selectedQuarter = Kpi({
		app,
		objectId: "jzfBCy",
	});

	return (
		<div className="app details">
			<div className="appContent">
      <Grid container rowGap={2} flexDirection={"column"} gap={"16px"}>
        <Grid item paddingBottom={"0px"} >
          <LayoutWrapper>
            <Card
              app={app}
              exportTable
              exportContainer
              exportTableId="HLdASk"
              header={{
                hardTitle: "Apuração por vendedor",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <NativeObject
                app={app}
                key="HLdASk"
                reference={{ id: "HLdASk" }}
                style={{ height: '525px' }}
              />

            </Card>
          </LayoutWrapper>

        </Grid>

        <Grid item>
          <LayoutWrapper>
            <Card
              app={app}
              exportTable
              exportContainer
              exportTableId="DjdbL"
              header={{
                hardTitle: "Apuração por CNPJ",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-table"}
            >
              <NativeObject
                app={app}
                key="DjdbL"
                reference={{ id: "DjdbL" }}
                style={{ height: '525px' }}
              />

            </Card>

          </LayoutWrapper>

        </Grid>

      </Grid>
			</div>
		</div>
	);
}

DetailsDesktop.defaultProps = {
	app: null,
	config: {},
};

DetailsDesktop.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default DetailsDesktop;
